import * as React from "react";
import { forwardRef } from "react";
const SvgCloseBtn = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 30, height: 30, fill: "none", viewBox: "0 0 20 21", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10.154, r: 10, fill: "#262C2E", opacity: 0.1 }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", d: "m7 13.154 3-3m3-3-3 3m0 0-3-3m3 3 3 3" }));
const ForwardRef = forwardRef(SvgCloseBtn);
export default ForwardRef;
